import { api } from '@/shared/lib/api';

export interface Reminder {
  id: string;
  userId: string;
  title: string;
  description: string | null;
  reminderDateTime: string;
  notifyBefore: number;
  scheduledAt: string;
  status: 'PENDING' | 'SENT' | 'FAILED' | 'CANCELLED';
  sentAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ReminderStats {
  PENDING: number;
  SENT: number;
  FAILED: number;
  CANCELLED: number;
}

export interface CreateReminderData {
  title: string;
  description?: string;
  reminderDateTime: string;
  notifyBefore: 5 | 15 | 30 | 60 | 120;
}

export interface UpdateReminderData {
  title?: string;
  description?: string;
  reminderDateTime?: string;
  notifyBefore?: 5 | 15 | 30 | 60 | 120;
}

export const remindersService = {
  /**
   * Lista todos os lembretes do usuário
   */
  async listReminders(status?: Reminder['status']): Promise<Reminder[]> {
    const queryParams = new URLSearchParams();
    if (status) queryParams.append('status', status);

    const response = await api.get<Reminder[]>(
      `/reminders${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
    );
    return response.data;
  },

  /**
   * Busca estatísticas de lembretes
   */
  async getStats(): Promise<ReminderStats> {
    const response = await api.get<ReminderStats>('/reminders/stats');
    return response.data;
  },

  /**
   * Busca um lembrete por ID
   */
  async getReminder(id: string): Promise<Reminder> {
    const response = await api.get<Reminder>(`/reminders/${id}`);
    return response.data;
  },

  /**
   * Cria um novo lembrete
   */
  async createReminder(data: CreateReminderData): Promise<Reminder> {
    const response = await api.post<Reminder>('/reminders', data);
    return response.data;
  },

  /**
   * Atualiza um lembrete
   */
  async updateReminder(id: string, data: UpdateReminderData): Promise<Reminder> {
    const response = await api.patch<Reminder>(`/reminders/${id}`, data);
    return response.data;
  },

  /**
   * Cancela um lembrete
   */
  async cancelReminder(id: string): Promise<Reminder> {
    const response = await api.post<Reminder>(`/reminders/${id}/cancel`);
    return response.data;
  },

  /**
   * Deleta um lembrete
   */
  async deleteReminder(id: string): Promise<void> {
    await api.delete(`/reminders/${id}`);
  },
};
